function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.define-properties.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import React, { useCallback, useMemo } from 'react';
import ReactList from "../react-list";
import NoteTemplate from "./NoteTemplate";
var NoteTemplatesList = function NoteTemplatesList(_ref) {
  var clickable = _ref.clickable,
    deletable = _ref.deletable,
    noteTemplates = _ref.noteTemplates,
    onArchiveTemplate = _ref.onArchiveTemplate,
    selectedTemplate = _ref.selectedTemplate,
    onSelectTemplate = _ref.onSelectTemplate,
    onChooseTemplate = _ref.onChooseTemplate,
    onDeleteTemplate = _ref.onDeleteTemplate;
  var onClick = function onClick(evt, template) {
    return onSelectTemplate(template);
  };

  // eslint-disable-next-line consistent-return
  var onDoubleClick = function onDoubleClick(evt, template) {
    if (typeof onChooseTemplate === 'function') {
      return onChooseTemplate(template);
    }
  };
  var deleteTemplate = function deleteTemplate(evt, template) {
    evt.stopPropagation();
    onDeleteTemplate(template);
  };
  var templates = useMemo(function () {
    return noteTemplates.map(function (_ref2) {
      var id = _ref2.id,
        attributes = _ref2.attributes;
      return _objectSpread({
        id: id
      }, attributes);
    });
  }, [noteTemplates]);
  var itemRenderer = useCallback(function (index, key) {
    var noteTemplate = templates[index];
    return /*#__PURE__*/React.createElement(NoteTemplate, {
      key: key,
      selected: selectedTemplate && noteTemplate.id === selectedTemplate.id,
      clickable: clickable,
      noteTemplate: noteTemplate,
      deletable: deletable,
      onClick: onClick,
      onArchiveTemplate: onArchiveTemplate,
      onDoubleClick: onDoubleClick,
      onDeleteTemplate: deleteTemplate
    });
  }, [templates, selectedTemplate]);
  return /*#__PURE__*/React.createElement(ReactList, {
    itemRenderer: itemRenderer,
    length: templates.length,
    type: "uniform",
    threshold: 500
  });
};
export default NoteTemplatesList;